(() => {
  let bound = false;
  let timer;
  const normalize = value => String(value || '').normalize('NFKC').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim().replace(/\s+/g, ' ');
  const stockRank = item => {
    if (Number(item.quantity) > 0) return 0;
    if (Number(item.quantity) < 0) return 1;
    const available = (item.shopify_variants || []).some(variant => variant.available === true || variant.available === 1 || variant.available === '1');
    return available ? 1 : 2;
  };
  const install = jq => {
    const original = jq.getJSON;
    if (original.sovaTitleStock) return;
    const cache = new Map();
    const statusCache = new Map();
    const wrapped = function (url, callback) {
      let parsed;
      try { parsed = new URL(url, location.href); } catch { return original.apply(this, arguments); }
      const params = parsed.searchParams;
      const query = normalize(params.get('q'));
      const isResults = /\/getresults\/?$/.test(parsed.pathname);
      const isInstant = /\/getwidgets\/?$/.test(parsed.pathname);
      const sort = params.get('sortBy');
      if (typeof callback !== 'function' || !/^searchserverapi\d*\.com$/.test(parsed.hostname) ||
          (!isResults && !isInstant) || query.length < 1 || query.length > 512 ||
          (sort && sort !== 'relevance') || params.has('queryBy[title]') ||
          (isResults && /\/collections\//.test(location.pathname))) {
        return original.apply(this, arguments);
      }
      const start = Math.max(0, Number(params.get('startIndex')) || 0);
      const size = Number(params.get('maxResults')) || 10;
      if (size < 1 || size > 250) return original.apply(this, arguments);
      const deferred = jq.Deferred();
      const children = [];
      let stopped = false;
      let finished = false;
      let baseline;
      let fallbackRequested = false;
      const handle = deferred.promise();
      const deliver = data => {
        if (stopped || finished) return;
        finished = true;
        clearTimeout(deadline);
        handle.status = 200;
        callback(data);
        deferred.resolve(data);
      };
      handle.abort = () => {
        stopped = true;
        clearTimeout(deadline);
        children.forEach(request => { if (request && request.abort) request.abort(); });
        deferred.reject(handle, 'abort');
        return handle;
      };
      const fetchData = address => new Promise((resolve, reject) => {
        const request = original.call(jq, address.replace(/([?&]callback=)%3F(?=&|$)/i, '$1?'), data => {
          if (!data || data.error) reject(new Error('Search response unavailable'));
          else resolve(data);
        });
        children.push(request);
        if (request && request.fail) request.fail(reject);
      });
      const fallback = () => {
        fallbackRequested = true;
        if (baseline) deliver(baseline);
      };
      const deadline = setTimeout(fallback, 8000);
      const nativePage = fetchData(parsed.href).then(data => {
        baseline = data;
        if (fallbackRequested) deliver(data);
        return data;
      });
      const titleURL = new URL(parsed);
      titleURL.searchParams.delete('q');
      titleURL.searchParams.set('queryBy[title]', query.split(' ').sort((a, b) => b.length - a.length)[0]);
      titleURL.searchParams.set('startIndex', '0');
      titleURL.searchParams.set('maxResults', '250');
      const keyURL = new URL(titleURL);
      keyURL.searchParams.delete('callback');
      const key = query + '|' + keyURL.href;
      const previous = cache.get(key);
      const titles = previous && Date.now() - previous.time < 30000 ? Promise.resolve(previous.items) : (async () => {
        let data = await fetchData(titleURL.href);
        const count = Number(data.totalItems) || 0;
        if (count > 1000) return [];
        let candidates = data.items || [];
        for (let offset = candidates.length; offset < count; offset += 250) {
          if (stopped || finished) throw new Error('Cancelled');
          titleURL.searchParams.set('startIndex', String(offset));
          data = await fetchData(titleURL.href);
          if (!(data.items || []).length) throw new Error('Incomplete title query');
          candidates = candidates.concat(data.items);
        }
        const unique = new Map();
        candidates.forEach(item => {
          const title = normalize(item.title);
          if (item.product_id && (title === query || title.startsWith(query + ' ') || (query.includes(' ') && title.startsWith(query)))) unique.set(String(item.product_id), item);
        });
        const items = [...unique.values()].sort((a, b) => stockRank(a) - stockRank(b));
        cache.set(key, {time: Date.now(), items});
        while (cache.size > 8) cache.delete(cache.keys().next().value);
        return items;
      })();
      Promise.all([nativePage, titles]).then(async ([data, exact]) => {
        if (stopped || finished || fallbackRequested) return;
        const promoted = exact.slice(start, start + size);
        const needed = size - promoted.length;
        let remaining = [];
        if (needed > 0) {
          const rest = new URL(parsed);
          const filter = rest.searchParams.get('restrictBy[product_id]');
          if (exact.length) {
            const exclusions = exact.map(item => '!' + item.product_id).join(',');
            rest.searchParams.set('restrictBy[product_id]', filter ? filter + ',' + exclusions : exclusions);
          }
          rest.searchParams.set('facets', 'true');
          rest.searchParams.set('startIndex', '0');
          rest.searchParams.set('maxResults', String(size));
          const selectedStatus = rest.searchParams.get('restrictBy[stock_status]');
          const statuses = ['В наличии', 'Предзаказ', 'Нет в наличии'];
          const activeStatuses = selectedStatus ? statuses.filter(value => selectedStatus.split('|').includes(value)) : statuses;
          const groupKeyURL = new URL(rest);
          groupKeyURL.searchParams.delete('callback');
          const groupKey = groupKeyURL.href;
          const savedGroups = statusCache.get(groupKey);
          let groups;
          if (savedGroups && Date.now() - savedGroups.time < 30000) groups = savedGroups.groups;
          else {
            groups = await Promise.all(activeStatuses.map(async (status) => {
              const address = new URL(rest);
              address.searchParams.set('restrictBy[stock_status]', status);
              const response = await fetchData(address.href);
              const rank = statuses.indexOf(status);
              if ((response.items || []).some(item => stockRank(item) !== rank)) throw new Error('Unexpected stock partition');
              return {url: address.href, count: Number(response.totalItems) || 0, items: response.items || []};
            }));
            if (groups.reduce((sum, group) => sum + group.count, 0) + exact.length !== Number(data.totalItems)) throw new Error('Incomplete stock partitions');
            statusCache.set(groupKey, {time: Date.now(), groups});
            while (statusCache.size > 8) statusCache.delete(statusCache.keys().next().value);
          }
          let offset = Math.max(0, start - exact.length);
          for (const group of groups) {
            if (stopped || finished) return;
            if (offset >= group.count) { offset -= group.count; continue; }
            const take = Math.min(needed - remaining.length, group.count - offset);
            if (take <= 0) break;
            let pageItems;
            if (offset + take <= group.items.length) pageItems = group.items.slice(offset, offset + take);
            else {
              const address = new URL(group.url);
              address.searchParams.set('startIndex', String(offset));
              address.searchParams.set('maxResults', String(take));
              pageItems = (await fetchData(address.href)).items || [];
            }
            if (pageItems.length !== take) throw new Error('Incomplete stock page');
            remaining = remaining.concat(pageItems);
            offset = 0;
          }
        }
        const items = promoted.concat(remaining);
        deliver(Object.assign({}, data, {items, currentItemCount: items.length}));
      }).catch(() => {
        if (baseline) fallback();
        else nativePage.then(fallback).catch(() => {
          if (stopped || finished) return;
          finished = true;
          clearTimeout(deadline);
          deferred.reject(handle, 'error');
        });
      });
      return handle;
    };
    wrapped.sovaTitleStock = true;
    jq.getJSON = wrapped;
  };
  const bind = () => {
    if (bound || !window.Searchanise || !window.Searchanise.$) return bound;
    const jq = window.Searchanise.$;
    install(jq);
    jq(document).on('Searchanise.DataRequestBefore.sovaSearchRelevance', (_event, type, params) => {
      if (type !== 'autocomplete' && type !== 'results') return;
      if (typeof params.q === 'string') params.q = params.q.replace(/(^|[^а-яё])достоевкий(?=$|[^а-яё])/gi, '$1достоевский');
      delete params.recentlyViewedProducts;
      delete params.recentlyAddedToCartProducts;
      delete params.recentlyPurchasedProducts;
    });
    bound = true;
    if (timer) clearInterval(timer);
    return true;
  };
  document.addEventListener('Searchanise.Loaded', bind, {once: true});
  if (!bind()) {
    let attempts = 0;
    timer = setInterval(() => {
      attempts += 1;
      if (bind() || attempts >= 80) clearInterval(timer);
    }, 250);
  }
})();
